import View from './index';
export default View;
